var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Payment"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Open"}},[_c('div',{staticClass:"tab-text"},[_c('pending')],1)]),_c('vs-tab',{attrs:{"label":"Approved"}},[_c('div',{staticClass:"tab-text"},[_c('approved')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }